export default __webpack_public_path__ + "src/images/packages/ngama-tented-lodge/509e776f3b655142ae7f77c8e910251c-3.jpg";